import React, {useEffect, useState} from "react"
import { useNavigate } from "react-router-dom"

import "./Main.css"
import more from "../assets/commonMore.svg"
import cardShopping from "../assets/cardShopping.svg"
import cardTest from "../assets/cardTest.svg"
import cardInquiry from "../assets/cardInquiry.svg"
import cardWebTest from "../assets/cardWebTest.svg"

import Nav from "../component/Nav/Nav"
import Footer from "../component/Footer/Footer"

// Swiper
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import { Autoplay, Pagination } from "swiper/modules"
import "swiper/css/pagination"
import {retrieveData, sendRequest} from "../common";

function Main() {

	const navigate = useNavigate()

	const [user, setUser] = useState()

	const [banners, setBanners] = useState([])

	const getBanners = () => {
		sendRequest('common/banner/', 'GET', null, data => {
			setBanners(data)
		})
	}

	useEffect(() => {
		retrieveData('user').then(data => {
			setUser(data)
		})
		getBanners()
	}, [sessionStorage.getItem('user')])

	return (
		<>
			<Nav user={user}/>

			<div className="bannerWrap">
				<Swiper
					className="bannerSlide"
					autoplay={{
						delay: 4000,
						disableOnInteraction: false,
					}}
					pagination={{
						clickable: true,
					}}
					modules={[Autoplay, Pagination]}>
					{banners?.map((item, index) => {
						return (
							<SwiperSlide key={`banners-${item?.id}-${index}`}>
								<div className="bannerItem">
									<p>{item?.name}</p>
									<h2>{item?.title}</h2>
									<div className="text">
										<span style={{maxWidth: 450}}>{item?.content}</span>
										{/*<span> 심리검사 해석 상담을 실시하고 있습니다.</span>*/}
									</div>
									<button type="button"
													onClick={() => {
														window.open(item?.url)
														// navigate(item?.url)
													}}>
										자세히 보기
									</button>
								</div>
							</SwiperSlide>
						)
					})}

					{/*<SwiperSlide>*/}
					{/*	<div className="bannerItem">*/}
					{/*		<p>공인된 차세대 심리성격검사</p>*/}
					{/*		<h2>PTS 온라인 검사 2</h2>*/}
					{/*		<div className="text">*/}
					{/*			<span>심리 성장과 치유를 돕기 위해 자기개념 영역의 심리유형 분석 상담과</span>*/}
					{/*			<span> 심리검사 해석 상담을 실시하고 있습니다.</span>*/}
					{/*		</div>*/}
					{/*		<button type="button"*/}
					{/*			onClick={() => {*/}
					{/*				navigate("")*/}
					{/*			}}>*/}
					{/*			자세히 보기*/}
					{/*		</button>*/}
					{/*	</div>*/}
					{/*</SwiperSlide>*/}
					{/*<SwiperSlide>*/}
					{/*	<div className="bannerItem">*/}
					{/*		<p>공인된 차세대 심리성격검사</p>*/}
					{/*		<h2>PTS 온라인 검사 3</h2>*/}
					{/*		<div className="text">*/}
					{/*			<span>심리 성장과 치유를 돕기 위해 자기개념 영역의 심리유형 분석 상담과</span>*/}
					{/*			<span> 심리검사 해석 상담을 실시하고 있습니다.</span>*/}
					{/*		</div>*/}
					{/*		<button type="button"*/}
					{/*			onClick={() => {*/}
					{/*				navigate("")*/}
					{/*			}}>*/}
					{/*			자세히 보기*/}
					{/*		</button>*/}
					{/*	</div>*/}
					{/*</SwiperSlide>*/}
				</Swiper>
			</div>

			<div className="sectionWrap">
				<section>
					<article className="atc01">
						<h3>
							<span>전문가</span>를 위한 서비스
						</h3>
						<div className="cardWrap">
							<div
								className="cardItem"
								onClick={() => {
									navigate("/purchase-online")
								}}>
								<div className="text">
									<h4>온라인 검사 구매</h4>
									<span>
										바로가기 <img src={more} alt="바로가기 아이콘" />
									</span>
								</div>
								<div className="icon">
									<img src={cardShopping} alt="온라인 검사 구매 아이콘" />
								</div>
							</div>
							<div
								className="cardItem"
								onClick={() => {
									navigate("/online-examination")
								}}>
								<div className="text">
									<h4>온라인 검사 실시</h4>
									<span>
										바로가기 <img src={more} alt="바로가기 아이콘" />
									</span>
								</div>
								<div className="icon">
									<img src={cardTest} alt="온라인 검사 실시 아이콘" />
								</div>
							</div>
						</div>
					</article>
					<article className="atc02">
						<h3>
							<span>고객</span>을 위한 서비스
						</h3>
						<div className="cardWrap">
							<div
								className="cardItem"
								onClick={() => {
									navigate("/inquire")
								}}>
								<div className="text">
									<h4>검사 문의 및 의뢰</h4>
									<span>
										바로가기 <img src={more} alt="바로가기 아이콘" />
									</span>
								</div>
								<div className="icon">
									<img src={cardInquiry} alt="검사 문의 및 의뢰 아이콘" />
								</div>
							</div>
							<div
								className="cardItem"
								onClick={() => {
									navigate("/start-test")
								}}>
								<div className="text">
									<h4>웹 검사 실시</h4>
									<span>
										바로가기 <img src={more} alt="바로가기 아이콘" />
									</span>
								</div>
								<div className="icon">
									<img src={cardWebTest} alt="웹 검사 실시 아이콘" />
								</div>
							</div>
						</div>
					</article>
				</section>
			</div>
			<Footer />
		</>
	)
}

export default Main
